"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = void 0;
const resolveZodIssuePath_1 = __importDefault(require("./resolveZodIssuePath"));
const isInstanceOfCustomError = (err) => {
    return Object.keys(err).includes("error_code");
};
const isInstanceOfFormError = (err) => {
    return Object.keys(err).includes("errors");
};
const isInstanceOfTRPCError = (err) => {
    return Object.keys(err).includes("data");
};
const isInstanceOfHttpError = (err) => {
    return Object.keys(err).includes("message");
};
/**
 *
 * handleError will normalize different type of errors into a single structure
 *
 * @param { APIError } error
 * @returns { SerializedError[] } returns a normalized object of error response
 */
const handleError = (error) => {
    const serializedErrors = [];
    if (error && error.errors) {
        const errorResponseBody = error.errors;
        let isPushed = false;
        if (isInstanceOfTRPCError(errorResponseBody)) {
            // Validation Errors i.e ZodErrorIssues
            if (errorResponseBody.data.issues) {
                errorResponseBody.data.issues.forEach((issue) => {
                    serializedErrors.push({
                        message: `${issue.message} at "${(0, resolveZodIssuePath_1.default)(issue.path)}"`,
                    });
                });
                isPushed = true;
            }
        }
        if (isInstanceOfCustomError(errorResponseBody) && !isPushed) {
            serializedErrors.push(Object.assign({ message: errorResponseBody.error_code, errorType: errorResponseBody.error_type }, (errorResponseBody.parameters && {
                parameters: errorResponseBody.parameters,
            })));
            isPushed = true;
        }
        if (isInstanceOfFormError(errorResponseBody) && !isPushed) {
            serializedErrors.push({
                message: "validationError",
                errorType: "validation_error",
            });
            isPushed = true;
        }
        if (!(Object.keys(errorResponseBody).length === 0) && !isPushed) {
            switch (error.statusCode) {
                case 404:
                    serializedErrors.push({
                        message: "notFound",
                        errorType: "notFound",
                    });
                    isPushed = true;
                    break;
                case 401:
                    serializedErrors.push({
                        message: "unauthorized",
                        errorType: "unauthorized",
                    });
                    isPushed = true;
                    break;
                case 403:
                    serializedErrors.push({
                        message: "unauthorized",
                        errorType: "unauthorized",
                    });
                    isPushed = true;
                    break;
                case 400:
                    serializedErrors.push({
                        message: "validationFailed",
                        errorType: "validationFailed",
                    });
                    isPushed = true;
                    break;
                case 429:
                    serializedErrors.push({
                        message: "tooManyRequest",
                        errorType: "tooManyRequest",
                    });
                    isPushed = true;
                    break;
                case 500:
                    serializedErrors.push({
                        message: "internalServerError",
                        errorType: "internalServerError",
                    });
                    isPushed = true;
                    break;
                case 503:
                    serializedErrors.push({
                        message: "serviceUnavailable",
                        errorType: "serviceUnavailable",
                    });
                    isPushed = true;
                    break;
            }
        }
        if (isInstanceOfHttpError(errorResponseBody) && !isPushed) {
            serializedErrors.push({
                message: errorResponseBody.message,
            });
        }
    }
    else {
        serializedErrors.push({
            message: "generic_error",
            errorType: "generic_error",
        });
    }
    return serializedErrors;
};
exports.handleError = handleError;
